<template>
    <div class="part">
        <p>{{ $t("Providing great shipping logistics for your store") }}</p>
        <span>
            {{
                $t(
                    "Store Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                )
            }}
        </span>
        <div class="center-text">
            <button class="button is-primary" @click="setAction">
                {{ $t("More details") }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        setAction() {
            this.$buefy.toast.open({
                message: this.$t("Coming Soon!"),
                type: "is-primary",
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.part {
    width: 100%;
    height: 100%;
    text-align: left;

    p {
        font-weight: bold;
        font-size: 1.8rem;
        width: 85%;
        line-height: 1.2;
        margin-bottom: 40px;
    }

    span {
        display: inline-block;
        margin-bottom: 40px;
    }

    .button {
        border-radius: 3px !important;
        width: 200px;
    }
}
</style>
